import React from "react";
import LcLayout from "./src/components/learningCenter/lcLayout";
import FadeInOnFontLoad from "./src/components/shared/fadeInOnFontLoad";
import { ReferralModalTSB } from "./src/components/shared/referralModal";

export const wrapRootElement = ({ element }) => <FadeInOnFontLoad>{element}</FadeInOnFontLoad>;

export const wrapPageElement = ({ element, props }) => {
  const path = props?.location?.pathname;
  const usesLcLayout = path && (path.startsWith("/learn/") || path === "/updates/");
  const Layout = usesLcLayout ? LcLayout : React.Fragment;

  return (
    <Layout {...(usesLcLayout && props)}>
      <ReferralModalTSB />
      {element}
    </Layout>
  );
};
